import { render, staticRenderFns } from "./ViewDeal.vue?vue&type=template&id=97cfa0ec&scoped=true"
import script from "./ViewDeal.vue?vue&type=script&lang=js"
export * from "./ViewDeal.vue?vue&type=script&lang=js"
import "./ViewDeal.vue?vue&type=style&index=0&id=97cfa0ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97cfa0ec",
  null
  
)

export default component.exports